import {toast} from '@/utilities/toast/toast'
import {useTranslation} from '@/translations/i18n'
import {useBugReporter} from '../hooks/useBugReporter'
import {useEnvironmentSnapshot} from '../hooks/useEnvironmentSnapshot'
import {AttachmentUploadState, BugReportFormValues, EnvironmentSnapshot} from '../types'
import {BugReporterDialog} from './BugReporterDialog/BugReporterDialog'

export const BugReporterProvider = () => {
    const {t} = useTranslation()
    const bugReporter = useBugReporter()
    const getSnapshot = useEnvironmentSnapshot()

    const handleSubmit = async (
        values: BugReportFormValues,
        snapshot: EnvironmentSnapshot,
        attachments: AttachmentUploadState[]
    ) => {
        const result = await bugReporter.submit(values, snapshot, attachments)
        if (result) {
            toast.success(t('bug_reporter:submit_success', {identifier: result.issue.identifier}))
            if (result.failedAttachments.length > 0) {
                toast.error(
                    t('bug_reporter:attachments_failed_notice', {
                        files: result.failedAttachments.join(', ')
                    })
                )
            }
        }
        return result
    }

    return (
        <BugReporterDialog
            isOpen={bugReporter.isOpen}
            onClose={bugReporter.close}
            onSubmit={handleSubmit}
            isSubmitting={bugReporter.isSubmitting}
            submitError={bugReporter.submitError}
            getSnapshot={getSnapshot}
        />
    )
}
